import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';
import { PinRateLimitError } from './authErrors';
import { PinPad } from './PinPad';
import './auth.css';

export function LoginPage() {
  const { user, loading, signInWithPin } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const destination = (location.state as { from?: string } | null)?.from ?? '/';

  if (!loading && user) return <Navigate to={destination} replace />;

  const handleSubmit = async (pin: string) => {
    setBusy(true);
    setError(null);
    try {
      await signInWithPin(pin);
    } catch (caught: unknown) {
      setError(
        caught instanceof PinRateLimitError
          ? caught.message
          : 'Prijava ni uspela. Preverite PIN in poskusite znova.',
      );
      throw new Error('PIN login failed', { cause: caught });
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-card" aria-labelledby="login-title">
        <img
          className="auth-logo"
          src="/Logo_WMS.png"
          alt="WMS"
          width="72"
          height="75"
        />
        <h1 id="login-title">Prijava</h1>
        <PinPad busy={busy || loading} error={error} onSubmit={handleSubmit} />
      </section>
    </main>
  );
}
